import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { FilterRequest, Response, LeadDraftInfoStatus } from '@core/api';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class LeadDraftInfoStatusService {
  constructor(private http: HttpClient) { }

  list(request: FilterRequest): Observable<Response<LeadDraftInfoStatus[]>> {
    return this.http.post<Response<LeadDraftInfoStatus[]>>(environment.apiUrl + '/api/LeadDraftInfoStatus/List', request);
  }
}
